import Marquee from "react-fast-marquee";

const ITEMS = [
  "10th Anniversary",
  "400+ Client Stores",
  "$1.4B in Managed Sales",
  "The Amazon Launch Program",
  "10 Seats Only",
  "$6,997 One-Time",
];

export function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-black/10 py-10"
    >
      <Marquee speed={28} gradient={false}>
        {ITEMS.map((item) => (
          <span
            key={item}
            className="mx-8 flex items-center gap-16 font-display text-5xl font-black uppercase tracking-tighter text-stroke md:text-7xl"
          >
            {item}
            <span className="text-signal" style={{ WebkitTextStroke: "0" }}>
              ·
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
